import { ICacheState } from 'store/types/cache'

export const getInitialState = (): ICacheState => ({
  aiImageCache: {},
  aiVideoCache: {}
})
